import { t } from "i18next";
import { isPresent } from "neetocist";

import {
  EMAIL_FORM_VALIDATION_SCHEMA,
  REPLY_TO_FIELD_VALIDATION,
  sendToFieldValidation,
  SEND_TO_ID_FIELD_VALIDATION,
} from "./constants";

export const getValidationSchema = ({
  showSendToField,
  showReplyToField,
  showSendToAsRadio,
  customValidations,
  maxEmails,
}) => {
  let schema = EMAIL_FORM_VALIDATION_SCHEMA.clone();

  if (showSendToField) {
    schema = schema.concat(
      showSendToAsRadio
        ? SEND_TO_ID_FIELD_VALIDATION
        : sendToFieldValidation(maxEmails)
    );
  }

  if (showReplyToField) schema = schema.concat(REPLY_TO_FIELD_VALIDATION);

  const isYupObject = customValidations.type === "object";

  if (isYupObject) {
    const customFields = customValidations.fields || {};
    schema = schema.shape(customFields);
  } else if (typeof customValidations === "object") {
    schema = schema.shape(customValidations);
  }

  return schema;
};

export const getReplyToFieldLabelProps = ({ popoverProps }) => ({
  helpIconProps: {
    ["data-testid"]: "reply-to-tooltip",
    tooltipProps: !isPresent(popoverProps) && {
      content: t("neetoMolecules.emailForm.tooltips.replyTo"),
      touch: ["hold", 500],
    },
    popoverProps: isPresent(popoverProps) && {
      ...popoverProps,
      appendTo: "parent",
      description:
        popoverProps.description ||
        t("neetoMolecules.emailForm.tooltips.replyTo"),
    },
  },
});

export const resolveContent = (content, func, variable) => {
  if (typeof func === "function") {
    return func(content, variable);
  }

  return content;
};

export const normalizeHtmlString = str => {
  if (typeof str !== "string") return str;

  return str
    .replace(/\uFEFF/g, "")
    .replace(/\r\n|\r/g, "\n")
    .replace(/&nbsp;/g, " ")
    .replace(/[\t ]+/g, " ")
    .replace(/\s*\n\s*/g, "\n")
    .replace(/\n+/g, "\n")
    .replace(/>\s+</g, "><")
    .trim();
};
